import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Divider,
} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import PostData from "../../services/PostData.js";

export default function VoidLabelDialog({ isOpen, onClose, onSuccess, shipment }) {
    const [submitLoad, setSubmitLoad] = useState(false);
    const [successSubmit, setSuccessSubmit] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSuccessSubmit(false);
            setErrorMessage("");
            setSubmitLoad(false);
        }
    }, [isOpen]);

    const handleConfirm = async () => {
        const shipmentId = shipment?.id;
        if (!shipmentId) return;
        setSubmitLoad(true);
        setErrorMessage("");
        const { success, error } = await PostData(
            {},
            `broylesllc/shipments/${shipmentId}/void-label`,
            null
        );
        setSubmitLoad(false);
        if (success) {
            setSuccessSubmit(true);
            setTimeout(() => {
                if (onSuccess) onSuccess();
                else onClose?.();
            }, 800);
            return;
        }
        const message =
            error?.response?.data?.message ||
            (typeof error?.response?.data === "string" ? error.response.data : "") ||
            error?.message ||
            "Could not void this UPS label.";
        setErrorMessage(String(message));
    };

    return (
        <Dialog open={isOpen} onClose={submitLoad ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ padding: "10px 15px 5px 15px" }}>
                Void UPS Label
            </DialogTitle>
            <Divider sx={{ borderColor: "black" }} />
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    Void the Bread Bskt UPS label for order{" "}
                    <strong>{shipment?.customerOrderNumber || "—"}</strong>
                    {shipment?.trackingNumber ? (
                        <>
                            {" "}
                            (tracking <strong>{shipment.trackingNumber}</strong>)
                        </>
                    ) : null}
                    ?
                </Typography>
                <Typography variant="body2" sx={{ mt: 1.5, color: "text.secondary" }}>
                    UPS will cancel/refund the label charges. This shipment returns to{" "}
                    <strong>Needs Label</strong> so you can buy a new label. This does{" "}
                    <strong>not</strong> cancel the marketplace order. If tracking was
                    already sent to eBay/Walmart, update that fulfillment separately if
                    needed.
                </Typography>
                {errorMessage ? (
                    <Typography color="error" sx={{ mt: 2, fontSize: 13 }}>
                        {errorMessage}
                    </Typography>
                ) : null}
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between" }}>
                <Button onClick={onClose} color="primary" disabled={submitLoad}>
                    Close
                </Button>
                <Button
                    loading={submitLoad}
                    disabled={submitLoad || successSubmit || !shipment?.id}
                    onClick={handleConfirm}
                    color="error"
                >
                    {successSubmit ? (
                        <>
                            <span>Success</span>
                            <CheckOutlinedIcon
                                fontSize="small"
                                sx={{ color: "white", marginLeft: "10px" }}
                            />
                        </>
                    ) : (
                        "Void label"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
